module.exports = __webpack_public_path__ + "static/media/building.9b37cdfe.svg";